import { render } from "./AgentLandingRegistration.vue?vue&type=template&id=4afe8ba4&scoped=true&lang=pug"
import script from "./AgentLandingRegistration.vue?vue&type=script&lang=js"
export * from "./AgentLandingRegistration.vue?vue&type=script&lang=js"

import "./AgentLandingRegistration.vue?vue&type=style&index=0&id=4afe8ba4&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afe8ba4"]])

export default __exports__